import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IAddToOrderCommand from '../SakhsSalesBimehNameh/Commands/Soddor/IAddToOrderCommand';
import { KhodroHttpPostService } from '../Services/KhodroHttpService';

export const addToOrder = createAsyncThunk('addToOrder', async (command: IAddToOrderCommand) => {
  return await KhodroHttpPostService({
    url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.AddToOrder}`,
    body: command,
  });
});
